<template>
    <div>
        <div>
            <el-button size="mini" icon="el-icon-plus" @click="toEdit(null)">新增</el-button>
            <el-select v-model="filter.type" placeholder="选择类型" size="mini" clearable class="w100">
              <el-option
                v-for="item in type_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select v-model="filter.country_code" placeholder="选择国家" size="mini" clearable class="w100">
              <el-option
                v-for="item in country_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-input size="mini" v-model="filter.code_name" clearable @clear="search" placeholder="搜关键字" class="w240 input-with-select">
                <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
            </el-input>
        </div>
        <el-table :data="list_data.list" v-loading="loading" style="width: 100%">
            <el-table-column prop="id" label="ID" width="100"></el-table-column>
            <el-table-column prop="type_name" label="类型" width="100"></el-table-column>
            <el-table-column prop="code_name" label="名称" width="200"></el-table-column>
            <el-table-column prop="country_code" label="国家" width="100"></el-table-column>
            <el-table-column prop="info" label="内容" min-width="200">
              <template slot-scope="scope">
                <div v-html="scope.row.content"></div>
              </template>
            </el-table-column>
            <el-table-column prop="ctime" label="操作" width="155" align="right">
                <template slot-scope="scope">
                    <el-tag size="mini" class="pointer" @click="toEdit(scope.row)">编辑</el-tag>
                    <el-tag size="mini" type="info" class="pointer" @click="remove(scope.row.id)">删除</el-tag>
                </template>        
            </el-table-column>
        </el-table>    
        <component :is="popName2" :item="editItem"></component>
    </div>
</template>
<script>
const edit = resolve => require(['@/pages/setting/language/_edit'], resolve);  
export default {
    components:{
        edit
    },
    data(){
        return {
            loading:false,
            popName2:null,
            editItem:null,
            filter:{
              code_name:'',
              country_code: '',
              type:'',
              page:1,
              size: 100,
            },
            list_data:{
                total:0,
                size:10,
                list:[],
            },
            type_options: [
              {value:1, label:'功能'},
              {value:2, label:'内容'},
            ],
            country_options: [
              {value:"US", label:'US'},
              {value:"DE", label:'DE'},
              {value:"FR", label:'FR'},
              {value:"JP", label:'JP'},
              {value:"KO", label:'KO'},
            ],
        }
    },
    methods:{
        toEdit(row = null){
            this.editItem = row
            this.popName2 = 'edit'
        },
        toRelation(row = null){
            this.editItem = row
            this.popName2 = 'relation'
        },
        search(){
            this.filter.page = 1;
            this.getList()
        },
        getList(){
            this.loading = true;
            this.$http.post('/v1/pri/language/list', this.filter)
            .then( (response) => {
                this.loading = false;
                var res = response.data;
                if (res.code == 1) {
                    this.list_data = res.data
                }
            })            
        },
        remove(id){
            this.$confirm('删除数据', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$store.commit('setLoading', {text:'正在移除..'});
                this.$http.post('/v1/pri/language/remove', {ids:[id]})
                    .then( (response) => {
                        this.$store.commit('setLoading', {text:false});
                        var res = response.data;
                        if (res.code == 1) {
                            this.$message({
                                message: '移除成功',
                                type: 'success'
                            });
                            this.getList()
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'warning'
                            });
                        }
                    })
                    .catch( (error) => {
                        this.$store.commit('setLoading', {text:false});
                    }) 
            }) 
        },
    },
    mounted(){
        this.getList()
    },
}
</script>


// WEBPACK FOOTER //
// src/pages/setting/language/_list.vue